import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GroupListing, GroupAddEdit } from './Pages';

export const GroupRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={GroupListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={GroupAddEdit} />
    </Fragment>
)